import clsx from 'clsx'
import { FullWidthBar, RadioFieldSet } from 'components/core-v2'
import React from 'react'
import { FormProvider, useForm } from 'react-hook-form'

import { ReconciliationResult } from '../reconciliation-result/reconciliation-result'
import { ReconciliationTable } from '../reconciliation-table/reconciliation-table'
import classes from './reconciliation-main.module.scss'

export const ReconciliationMain = () => {
  const form = useForm({ defaultValues: { assetRadioFilter: 'all' } })
  return (
    <main className={clsx(classes.main, 'px-6')}>
      <FormProvider {...form}>
        <FullWidthBar shouldPadXAxis={false} size="large">
          <div className={classes.resultsBar}>
            <ReconciliationResult />
            <RadioFieldSet
              legend=""
              name="assetRadioFilter"
              options={[
                { label: 'All', value: 'all' },
                { label: 'Break', value: 'break' },
                { label: 'Warning', value: 'warning' }
              ]}
            />
          </div>
        </FullWidthBar>
        <ReconciliationTable />
      </FormProvider>
    </main>
  )
}
